'use client';
import React, { useState } from 'react';

const testimonials = [
  {
    stars: 5,
    quote:
      '"TechSonar was exceptional when addressing our sense of urgency with regards to an important compliance timeline, and they were able to deliver effectively, implementing critical security controls across our infrastructure."',
    source: 'Banking · Client Review',
  },
  {
    stars: 5,
    quote:
      '"Great option for agile security, especially if GTM timelines are tight. This is especially important when the release train comes with a lot of new products and releases, making it hard to keep the pace in a traditional ad-hoc model."',
    source: 'Technology · Client Review',
  },
  {
    stars: 5,
    quote:
      'TechSonar provides continuous DevSecOps for our critical web and mobile features. Each month they help us validate new functionalities in production, delivering relevant findings and strong value for money. We are very satisfied with their engineering-first approach.',
    source: 'Retail · Client Review',
  },
  {
    stars: 5,
    quote:
      '"The TechSonar team was fast and provided the exact solution we needed for our SOC2 readiness programme. We chose them because they provide a DevSecOps service that fits the way we work in terms of speed and communication. Highly recommended!"',
    source: 'Banking · Client Review',
  },
  {
    stars: 5,
    quote:
      '"We greatly value our partnership with TechSonar. Their exceptional security engineering services and effective communication have significantly enhanced our cybersecurity posture, ensuring the safety and trust of our customers\u2019 financial information."',
    source: 'FinTech · Client Review',
  },
  {
    stars: 5,
    quote:
      '"The management of communication channels and the centralisation of interactions with the team made the experience much more agile and effective. Having everything in one place was a huge advantage and allowed us to complete our ISO 27001 programme within just a few months."',
    source: 'Enterprise · Client Review',
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-1">
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="16" height="16" viewBox="0 0 16 16" fill="#80edfa">
          <path d="M8 1L10.09 5.26L14.82 5.97L11.41 9.29L12.18 14L8 11.77L3.82 14L4.59 9.29L1.18 5.97L5.91 5.26L8 1Z" />
        </svg>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  const handlePrev = () => setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  const handleNext = () => setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));

  const t = testimonials[current];

  return (
    <section className="bg-[#050a0f] border-t border-[#222] py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="mb-16">
          <p className="font-mono-brand text-[0.7rem] text-[#80edfa] uppercase tracking-widest mb-4">
            Testimonial
          </p>
          <h2 className="font-heading text-[clamp(2rem,4vw,3rem)] text-[#f5f5f8] font-medium">
            Trusted by engineering teams that take security seriously
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="testimonial-card max-w-3xl">
          <StarRating count={t.stars} />
          <p className="mt-6 text-lg text-[#f5f5f8] leading-relaxed font-sans">
            {t.quote}
          </p>
          <p className="mt-6 font-mono-brand text-[0.65rem] text-[#666] uppercase tracking-widest">
            {t.source}
          </p>
        </div>

        {/* Controls */}
        <div className="flex items-center justify-between mt-10 max-w-3xl">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 text-sm text-[#aaa]">
              <span className="font-mono-brand text-[0.65rem] uppercase tracking-widest">4.9/5</span>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="#80edfa">
                <path d="M6 0.5L7.57 3.7L11.12 4.22L8.56 6.71L9.14 10.25L6 8.6L2.86 10.25L3.44 6.71L0.88 4.22L4.43 3.7L6 0.5Z" />
              </svg>
            </div>
            <div className="flex items-center gap-2 text-sm text-[#aaa]">
              <span className="font-mono-brand text-[0.65rem] uppercase tracking-widest">Read full reviews</span>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M2 6H10M7 3L10 6L7 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <div className="flex gap-3">
            <button
              onClick={handlePrev}
              className="w-10 h-10 border border-[#222] flex items-center justify-center text-[#f5f5f8] hover:border-[#80edfa] transition-colors"
              aria-label="previous slide"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M10 3L5 8L10 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button
              onClick={handleNext}
              className="w-10 h-10 border border-[#222] flex items-center justify-center text-[#f5f5f8] hover:border-[#80edfa] transition-colors"
              aria-label="next slide"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 3L11 8L6 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
